<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="$rules.AddUser">
            <el-row >
                <el-col :span="type == 'add' ? 11 : 22" v-if="type == 'add'" >
                     <el-form-item label="账号：" prop="account">
                        <el-input  v-model="form.account" placeholder="请选择账号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="type == 'add'">
                     <el-form-item label="密码：" prop="pdk" label-width="80px">
                        <el-input type="password" v-model="form.pdk" placeholder="请输入密码"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="22">
                    <el-form-item label="所属部门：" class="el_main" prop="deptId">
                      <el-select
                              style="width:100%"
                              v-model="form.deptId"
                              filterable
                              remote
                              reserve-keyword
                              clearable
                              placeholder="搜索获取更多部门 "
                              :remote-method="departmentRemoteMethod"
                              :loading="loading">
                              <div style="color:rgb(245 108 108);margin-left:20px;font-size:12px">默认前10条,请搜索关键字</div>
                              <el-option
                              v-for="(item,index) in departmentList"
                              :key="index"
                              :label="item.name"
                              :value="item.id">
                              </el-option>
                          </el-select>
                    </el-form-item>
                </el-col>
              <el-col :span="22">
                <el-form-item label="手机号码：" prop="mobilePhone">
                  <el-input v-model="form.mobilePhone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        deptId: '',
        mobilePhone: '' // 添加 mobilePhone 属性
      },
      loading: false,
      departmentList: [],
      deptIds: null
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          var Submitform = {}
          if (that.type === 'add') {
            Submitform = {
              user: {
                account: that.form.account,
                pdk: that.form.pdk,
                mobilePhone: that.form.mobilePhone // 添加 mobilePhone 字段
              },
              deptId: that.form.deptId
            }
          } else {
            Submitform = {
              id: that.form.userDeptId,
              userId: that.form.id,
              deptId: that.form.deptId,
              mobilePhone: that.form.mobilePhone // 添加 mobilePhone 字段
            }
          }
          var RequestType = that.type === 'add' ? 'post' : 'put'
          var RequestTypeText = that.type === 'add' ? '添加' : '修改'
          var RequestUrl = that.type === 'add' ? '"/ucenter/user/saveGovUser"' : '"/ucenter/user/updateGovUser"'
          // eslint-disable-next-line
          eval(
                `that.$http.${RequestType}(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => {
                    if(res.status == 200){
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false)
                        that.$emit('Render')
                    } else {
                        that.$message.error('${RequestTypeText}失败')
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    },
    // js暂停的方法
    sleep (interval) {
      return new Promise(resolve => {
        this.loading = true
        setTimeout(resolve, interval)
      })
    },
    async Layoutfun (query = '', data, Parameter1) {
      if (query !== '') {
        await this.sleep(150)
        this.loading = false
        // eslint-disable-next-line no-eval
        return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
      } else {
        return data.slice(0, 10)
      }
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.Layoutfun(query, this.$department.list(), 'name').then(res => {
        this.departmentList = res
        this.addValueOptions()
      })
    },
    // 修改回显问题
    addValueOptions () {
      if (this.deptIds) {
        const target = this.$department.list().find((item) => { // 从大option中找到当前条
          return item.id === this.deptIds
        })
        if (target) { // 将当前条与小option比对，没有则加入
          if (this.departmentList.every(item => item.id !== target.id)) {
            this.departmentList.unshift(target)
          }
        }
      }
    }
  },
  created () {
    if (JSON.stringify(this.row) !== '{}') {
      this.form = JSON.parse(JSON.stringify(this.row))
      this.deptIds = this.form.deptId
    }
    this.departmentRemoteMethod()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
</style>
